import request from "../request";
import qs from 'qs'
import CryptoJs from 'crypto-js'
import { sendNationCaptchaName, companyInfo, NODE_API, FILEACTIONURL } from '../../config'

export const ListTransactionPublicityPaging = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/ListTransactionPublicityPaging',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getWebsiteProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getWebsiteProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 常态供应项目情况
export const getAdminRoomSelectionList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getAdminRoomSelectionList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}
// 资格证公示
export const getTransactionPublicList = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transactionPublic/list',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 资料下载左侧列表
export const getAttachmentList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/attachment/topN?' + data,
            method: 'get',
            headers: { 'Content-Type': 'application/json' },
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 资料下载右侧内容
export const getAttachmentDetail = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/attachment/getDetail?' + data,
            method: 'get',
            headers: { 'Content-Type': 'application/json' },
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 政策文件左侧列表
export const getPolicyList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/policy/topN?' + data,
            method: 'get',
            headers: { 'Content-Type': 'application/json' },
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 资料下载右侧内容
export const getPolicyDetail = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/policy/getDetail?' + data,
            method: 'get',
            headers: { 'Content-Type': 'application/json' },
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
// 轮候供应项目情况
export const getAdminIntendedProjectCountList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/intendedProjects/getAdminIntendedProjectCountList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data,
        })
            .then((response) => {
                resolve(response)
            })
            .catch((error) => {
                reject(error)
            })
    })
}

export const getWebsiteHouse = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/houses/getWebsiteHouse',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTransactionList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/list',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyTransactionLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/myTransactionList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const projectDetailInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getRoomTypeByProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getRoomTypeByProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const sendNationCaptcha = (params) => {
    return new Promise((resolve, reject) => {
        params.country = '86'
        params.productName = sendNationCaptchaName
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/captcha/sendNationCaptcha',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getUserProjectSummaryInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserProjectSummaryInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const doRegister = (params) => {
    return new Promise((resolve, reject) => {
        params.companyCode = companyInfo.companyCode
        params.companyName = companyInfo.companyName
        if (params.loginPwd) params.loginPwd = CryptoJs.MD5(trims(params.loginPwd)).toString()
        if (params.loginUser) params.loginUser = trims(params.loginUser)
        if (params.mobile) params.mobile = trims(params.mobile)
        if (params.username) params.username = trims(params.username)
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/register',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const checkCaptcha = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/captcha/verifyCaptcha',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const forgetPassword = (params) => {
    return new Promise((resolve, reject) => {
        if (params.loginPwd) params.loginPwd = CryptoJs.MD5(params.loginPwd).toString()
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/forgetPassword',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getAllProjectList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getAllProjectList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getProjectDetails = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const projectWebDetailInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/projectWebDetailInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserProjectSummaryInfos = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserProjectSummaryInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyQueueLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myQueueList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyReserveLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myReserveList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserBillLists = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/bills/getUserBillList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMyContracts = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/getMyContract',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getContractInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/contracts/getContractDetail',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getTransactionDetailById = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getTransactionDetailById',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyTransactionCheck = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/applyTransactionCheck',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const printTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/printTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const repairMaterials = (params) => {
    return new Promise((resolve, reject) => {
        // const data = qs.stringify(params)
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/repairMaterials',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

export const getCollectProjects = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/collectProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getMessages = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/message/list',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const progressQuery = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/progressQuery',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const myQueueList = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/myQueueList',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getApplyingTransaction = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getApplyingTransaction',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const applyQueue = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/applyQueue',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUserHouseListInProject = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/projects/getUserHouseListInProject',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const userReserve = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/userReserve',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getUpdateUser = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/updateUser',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCancelQueue = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/cancelQueue',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCancelReserve = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/reserves/cancelReserve',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const transactionApply = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/apply',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveTheBeforehand = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/saveTheBeforehand',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const transactionUpdate = (params) => {
    return new Promise((resolve, reject) => {
        const data = JSON.stringify(params)
        request({
            url: NODE_API + '/transaction/update',
            method: 'post',
            headers: { 'Content-Type': 'application/json' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveOrCommitFlag = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/getSaveOrCommitFlag',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setToloadBeforeSaveData = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/transaction/toloadBeforeSaveData',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCompanyMenu = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/companys/getCompanyMenu',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const getCompanyInfo = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/companys/getCompanyInfo',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}
export const setSaveOrCommitTimeByUserId = (params) => {
    return new Promise((resolve, reject) => {
        const data = qs.stringify(params)
        request({
            url: NODE_API + '/users/getSaveOrCommitTimeByUserId',
            method: 'post',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            data
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}

// 上传图片
export const uploadFile = (params, obj) => {
    return new Promise((resolve, reject) => {
        console.log(params);
        // const data = qs.stringify(params)
        let fd = new FormData();    //定义参数
        fd.append('file', params)
        fd.append('output', obj.output)
        fd.append('scene', obj.scene)
        fd.append('suffix', obj.suffix)
        if (obj.flag === 1) {
            fd.append('flag', obj.flag)
        }
        request({
            url: FILEACTIONURL,
            method: 'post',
            headers: { 'Content-Type': 'multipart/form-data;' },
            data: fd
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}


// tinifyAPI压缩图片
export const shrink = (params, obj) => {
    return new Promise((resolve, reject) => {
        console.log(params);
        // const data = qs.stringify(params)
        let fd = new FormData();    //定义参数
        fd.append('file', params)

        request({
            auth: {
                username: '18511999913@163.com',
                password: 'mlBm48sq4B1NmgtrppmykBfvHvqQdt9k'
            },
            url: 'https://api.tinify.com/shrink',
            method: 'post',
            data: fd
        }).then(response => {
            resolve(response)
        }).catch(error => {
            reject(error)
        })
    })
}